module.exports = __webpack_public_path__ + "static/img/graphswiper2.aa6bef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/graphswiper2.png
// module id = 9IL+
// module chunks = 170